import React from 'react';

const IconSmile3: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M39.9481 13.4173C39.0963 12.5303 38.0341 11.8025 36.8305 11.5503C35.2434 11.2175 33.5767 11.7481 32.2097 12.6202C30.8428 13.4923 29.7169 14.685 28.5699 15.8311C26.91 17.4895 25.1229 19.1086 22.9421 19.9732C20.8318 20.8099 18.0697 20.8811 16.2807 19.3241C14.4647 17.7439 12.1492 13.1657 11.273 12.2874C10.5107 11.4178 9.33009 11.0131 8.08509 11.9251C5.73941 13.6919 5.09373 16.4902 5.14567 18.8187C5.24706 23.3524 6.68521 27.6056 9.72011 30.9751C12.755 34.3447 16.5762 36.1592 21.0937 36.5557C34.1041 37.1295 39.151 30.7276 39.8915 29.8592C42.8307 26.4128 44.7223 18.1914 39.9481 13.4173Z" fill="#FFB7FA" />
  </svg>
);

export default IconSmile3;
